export type MooringProductionTaskType = (typeof MooringProductionTaskType)[keyof typeof MooringProductionTaskType];

export const MooringProductionTaskType = {
  AnchorLinePicking: 1,
  AnchorLineAssembly: 2,

  GridLinePicking: 3,
  GridLineAssembly: 4,

  BuoyPicking: 5,
  BuoyAssembly: 6,

  BridlePicking: 7,
  BridleAssembly: 8,

  FleetAnchorLinePicking: 9,
  FleetAnchorLineAssembly: 10,

  Packaging: 11,
  Splicing: 12,
} as const;

export const MooringProductionTaskTypeOptions: {
  id: MooringProductionTaskType;
  label: string;
}[] = [
  {
    id: 1,
    label: 'mooring.hours.pickingAnchorLine',
  },
  {
    id: 2,
    label: 'mooring.hours.assemblyAnchorLine',
  },
  {
    id: 3,
    label: 'mooring.hours.pickingGridLine',
  },
  {
    id: 4,
    label: 'mooring.hours.assemblyGridLine',
  },
  {
    id: 5,
    label: 'mooring.hours.pickingBuoy',
  },
  {
    id: 6,
    label: 'mooring.hours.assemblyBuoy',
  },
  {
    id: 7,
    label: 'mooring.hours.pickingBridle',
  },
  {
    id: 8,
    label: 'mooring.hours.assemblyBridle',
  },
  {
    id: 9,
    label: 'mooring.hours.pickingFleetAnchorLine',
  },
  {
    id: 10,
    label: 'mooring.hours.assemblyFleetAnchorLine',
  },
  {
    id: 11,
    label: 'mooring.hours.packing',
  },
  {
    id: 12,
    label: 'mooring.hours.splicing',
  },
];

// Base class for common properties
export abstract class MooringHoursBaseDto {
  Hours: number;
  Comment: string;
  UserId: string;
  Date: Date;
  Task: MooringProductionTaskType;

  constructor() {
    this.Hours = 0;
  }
}

export class AddHoursProductionOrderDto extends MooringHoursBaseDto {
  constructor() {
    super();
  }
}

export class UpdateHoursProductionOrderDto extends MooringHoursBaseDto {
  constructor() {
    super();
  }
}

export class HourProductionOrderDto extends MooringHoursBaseDto {
  Id: number;
  UserName: string;
  Created: Date;
  Updated: Date;
  RegisteredById: string;
  RegisteredByName: string;

  constructor() {
    super();
    this.Id = 0;
  }
}
